module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjkiIHZpZXdCb3g9IjAgMCAxMiA5IiB3aWR0aD0iMTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBmaWxsPSIjZDYwYzhjIiBkPSJtMTEuMDEwNzUyNyAwLTcuMDc1MjY4ODMgNy4wNS0yLjk0NjIzNjU2LTIuOTM1NzE0MjktLjk4OTI0NzMxLjk4NTcxNDI5IDMuNDQwODYwMjIgMy40Mjg1NzE0My40OTQ2MjM2NS40NzE0Mjg1Ny40OTQ2MjM2Ni0uNDcxNDI4NTcgNy41Njk4OTI0Ny03LjU0Mjg1NzE0eiIgdHJhbnNmb3JtPSIiLz48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ../core/src/assets/images/global-checkmark.svg
// module id = 266
// module chunks = 0